import styles from './ProductCaption.module.scss';

import type { ReferencedEntry } from 'contentful';
import React from 'react';

import type { Product } from 'api/contentful/contentTypes.cloverdotcom';
import { ButtonLinkV2 } from 'components/Button/ButtonLinkV2';
import { Blurb } from 'components/Contentful/Blurb';
import { Text } from 'components/Contentful/Text';
import { ProductPrice } from 'components/ProductPrice/ProductPrice';
import { flattenContentfulData } from 'services/cms/flattenContentful';
import { getField, isEntry } from 'utils/EntryUtil';
import { RichBlurb } from 'components/RichBlurb/RichBlurb';

interface ICaptionProps {
  entry?: ReferencedEntry<Product>;
  tabIndex?: number;
}

export const ProductCaption: React.FC<ICaptionProps> = ({ entry, tabIndex }) => {
  if (!isEntry(entry)) return null;

  const link = getField(entry, 'link');
  const flattenLink = link && flattenContentfulData(link);

  return (
    <>
      <div className={styles.title}>
        <Text tagName="h4" entry={entry} field="title" />
      </div>
      <div className={styles.pricing}>
        <ProductPrice className={styles.price} entry={entry} />
      </div>
      <div className={styles.blurbWrap}>
        <Blurb entry={entry} field="blurb" className={styles.blurb} />
        <RichBlurb document={getField(entry, 'richBlurb')} className={styles.blurb} />
      </div>
      {flattenLink?.title && (
        <ButtonLinkV2
          entry={flattenContentfulData(link)}
          className={styles.link}
          tabIndex={tabIndex}
          isButton
          isFullWidth
        />
      )}
    </>
  );
};
